/* eslint-disable no-unused-vars */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import process from './process/saga';
import request from './request/saga';
import request_detail from './request_detail/saga';
import search from './search/saga';
import request_answer from './request_answer/saga';
import upload from './upload/saga';
import upload_patent from './upload_patent/saga';
import request_detail_file from './request_detail_file/saga';
import request_geo_country from './request_geo_country/saga';
import request_experience from './request_experience/saga';
import request_user_chat from './request_user_chat/saga';
import request_message from './request_message/saga';
import request_detail_health_registry from './request_detail_health_registry/saga';
import request_detail_delivery_term from './request_detail_delivery_term/saga';
import supplier_email from './supplier_email/saga';
import request_detail_bmp_agency_maker from './request_detail_bmp_agency_maker/saga';
import request_detail_bmp_agency_packager from './request_detail_bmp_agency_packager/saga';
import request_detail_iso from './request_detail_iso/saga';
import request_detail_ghtf from './request_detail_ghtf/saga';
import request_detail_green_certificate from './request_detail_green_certificate/saga';
import request_detail_eco from './request_detail_eco/saga';
import request_eco from './request_eco/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    process(),
    request(),
    request_detail(),
    search(),
    request_answer(),
    upload(),
    upload_patent(),
    request_detail_file(),
    request_geo_country(),
    request_experience(),
    request_user_chat(),
    request_message(),
    request_detail_health_registry(),
    request_detail_delivery_term(),
    supplier_email(),
    request_detail_bmp_agency_maker(),
    request_detail_bmp_agency_packager(),
    request_detail_iso(),
    request_detail_ghtf(),
    request_detail_green_certificate(),
    request_detail_eco(),
    request_eco()
  ]);
}
